<template>
  <div class="swiper banner-swiper">
    <div class="swiper-wrapper">
      <!-- <div class="swiper-slide"><img src="@/assets/images/image1.jpg" /></div> -->
      <!-- <div class="swiper-slide"><img src="@/assets/images/image2.jpg" /></div> -->
      <!-- <div class="swiper-slide"><img src="@/assets/images/image3.jpg" /></div> -->
      <a
        href="javascript:void(0);"
        class="swiper-slide"
        v-for="(item, idx) in data.swiper.data"
        :key="idx"
        @click="btnCmd('select', item)"
        :style="{
          cursor:
            item.linkUrl && item.linkUrl.length > 5 ? 'pointer' : 'default',
        }"
      >
        <p style="text-align: center">{{ item.popupTitleNm }}</p>
        <div v-if="item.popupTypeCd && item.popupTypeCd == 'IMG'">
          <img
            v-if="
              item.filePath == null ||
              item.filePath == '' ||
              item.physFileNm == null ||
              item.physFileNm == '' ||
              item.noImgFlag == true
            "
            src="@/assets/images/common/img_no_product.svg"
            class="no-image"
            alt="No Image"
          />
          <img
            v-else
            :src="FILE_CDN_URL + item.filePath + '/' + item.physFileNm"
            alt=""
            @error="() => (item.noImgFlag = true)"
          />
        </div>
        <div
          v-if="item.popupTypeCd && item.popupTypeCd == 'TEXT'"
          v-html="sanitizeHTML(item.popupCn)"
        ></div>
      </a>
    </div>
    <div v-if="data.swiper.data.length > 1" class="c-swiper-buttons">
      <div>{{  data.swiper.data.length }}</div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev">
        <span class="sr-only">이전 슬라이드</span>
        <i class="c-icon icon-arrow size-small"></i>
      </div>
      <div class="swiper-button-next">
        <span class="sr-only">다음 슬라이드</span>
        <i class="c-icon icon-arrow size-small"></i>
      </div>
    </div>
    <div v-else class="c-swiper-buttons">
      {{  data.swiper.data.length }}
    </div>
  </div>
</template>
<script setup name="commonPopSwiper">
import { onMounted, ref, reactive, defineProps, watch } from "vue";
import Swiper, { Pagination, Navigation, Autoplay } from "swiper";
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;

import { useRouter } from "vue-router";

const router = useRouter();
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import * as cmUtil from "@/utils/cmUtil";

const swiperInstance = ref(null);

const props = defineProps({
  type: {
    type: String,
    default: "",
  },
  data: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    default: Object,
  },
});

const data = reactive({
  swiper: {
    type: props.type,
    data: props.data.map((_itm) => ({ ..._itm, noImgFlag: false })),
    options: props.options,
  },
});

function initializeSwiper() {
  return new Promise((resolve) => {
    if (document.readyState === "complete") {
      resolve();
    } else {
      document.addEventListener("DOMContentLoaded", () => {
        resolve();
      });
    }
  });
}

/**********************
 * 스와이퍼 호출
 *********************/
function initSwiper() {
  const swiperElement = document.querySelector(".banner-swiper");
  
  if (swiperElement) {
    swiperInstance.value = new Swiper(swiperElement, {
      modules: [Pagination, Navigation, Autoplay],
      speed: 400,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: ".banner-swiper .swiper-button-next",
        prevEl: ".banner-swiper .swiper-button-prev",
      },
      pagination: {
        el: ".banner-swiper .swiper-pagination",
        type: "fraction",
        renderFraction: (currentClass, totalClass) => {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
      on: {
        touchStart: function () {
          this.autoplay.stop(); // 터치 시작하면 자동 재생 중지
        },
      },
    });
    
    if(data.swiper.data.length <= 1){
      swiperInstance.value?.autoplay?.stop(); 
    }
  }
}

watch(
  () => props.data,
  (newValue) => {
    data.swiper.data = newValue;
    initializeSwiper().then(initSwiper);
  }
);

onMounted(() => {
  // initializeSwiper().then(initSwiper);
});

/**********************
 * 버튼 클릭 모음
 *********************/

async function btnCmd(cmd = "", parms = {}) {
  if (cmd == "select") {
    if (parms.linkUrl && parms.linkUrl.indexOf("http") > -1) {
      let goUrl = parms.linkUrl;
      let width = parms.width || 800;
      let height = parms.height || 600;
      if (parms.linkTypeCd === "NEW") {
        window.open(goUrl, "_blank", `width=${width},height=${height}`); // 새 창으로 열기
      } else {
        location.href = goUrl;
      }
    } else if (parms.linkUrl && parms.linkUrl.indexOf("/paintpro/") > -1) {
      let goUrl = parms.linkUrl;
      router.push({
        path: goUrl,
      });
    }
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}
</script>
